// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jLtfsXHbRzJece {\n  height: auto;\n  position: relative;\n}\n.bB80RS6KDcervb {\n  cursor: default;\n  float: left;\n  font-size: 14px;\n  height: 32px;\n  line-height: 32px;\n  margin: 0 8px 0 4px;\n  overflow: hidden;\n  position: relative;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"board-header": "jLtfsXHbRzJece",
	"boardTemplateBadgeContainer": "bB80RS6KDcervb"
};
export default ___CSS_LOADER_EXPORT___;
